"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 55.32 24",
    width: "55.32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m54.69 0h-39.88a.65.65 0 0 0 -.65.62v15.5a.64.64 0 0 0 .65.62h10.79v3h-.6a3.12 3.12 0 0 0 -5.92.13 3.12 3.12 0 0 0 -5.94-.1h-.56v-14.11a.63.63 0 0 0 -.64-.66h-5.65a.62.62 0 0 0 -.55.32l-3.1 5.58-2.46 2.48a.67.67 0 0 0 -.18.45v6.91a.63.63 0 0 0 .63.63h2.65a3.13 3.13 0 0 0 6.17 0h3.55a3.13 3.13 0 0 0 6.08.4 3.12 3.12 0 0 0 6.07-.43h12.93a3.12 3.12 0 0 0 6.07.44 3.13 3.13 0 0 0 6.08-.41h4.46a.63.63 0 0 0 .63-.63v-20.11a.63.63 0 0 0 -.63-.63zm-45.91 18.86h2.22v.94h-1.68a3.12 3.12 0 0 0 -.54-.94zm-4.88-7a.78.78 0 0 0 .1-.15l2.85-5.12h4.15v10.69h-9.43v-3zm-2.34 7h2.38a3 3 0 0 0 -.53.94h-1.85zm4.8 3.86a1.89 1.89 0 1 1 1.89-1.89 1.89 1.89 0 0 1 -1.89 1.89zm9.72 0a1.89 1.89 0 1 1 1.92-1.89 1.89 1.89 0 0 1 -1.92 1.89zm6 0a1.89 1.89 0 1 1 1.89-1.89 1.89 1.89 0 0 1 -1.92 1.89zm19.12 0a1.89 1.89 0 1 1 1.88-1.89 1.89 1.89 0 0 1 -1.91 1.89zm6 0a1.89 1.89 0 1 1 1.8-1.86 1.89 1.89 0 0 1 -1.86 1.88zm6.59-2.94h-3.6v.22a3.12 3.12 0 0 0 -6 0 3.13 3.13 0 0 0 -5.94-.14h-11v-3.74c0-.69-.08-.92-.94-1h-10.59c0-2.23 0-13.61 0-13.61h38z",
    fill: "#93c01f"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m5.53 12.55a.8.8 0 0 0 1-.33l1.6-3.13h1.3c.35 0 .63-.45.63-.8a.75.75 0 0 0 -.63-.75h-1.89a.63.63 0 0 0 -.54.35l-1.91 3.77a.75.75 0 0 0 .44.89z",
    fill: "#93c01f"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m31.07 15.51v-10.96l9.13 5.48z",
    fill: "#9ece06"
  }));
};

exports["default"] = _default;